import { gql } from "@apollo/client/core";


export const AGENDA = gql`
query Agenda($culture: String!, $first: Int!, $skip: Int!) {
    agenda(where: {localization: {culture: $culture}}, first: $first, skip: $skip) {
      displayText
      startTime
      endTime
      phone
      city {
        contentItems {
          __typename
          ... on City {
            name
          }
        }
      }
      cover {
        paths
        texts
      }
      localization {
        localizationSet
      }
    }
  }
`

export const AGENDA_DETAILS = gql`
query AgendaDetails($localizationSet: String!, $culture: String!) {
    agenda(where: {localization: {culture: $culture, localizationSet: $localizationSet}}) {
      __typename
      contentItemId
      displayText
      startTime
      endTime
      address
      phone
      cover {
        paths
        texts
      }
      location {
        latitude
        longitude
      }
      content {
        contentItems {
          contentItemId
          contentType
        }
      }
      items {
        contentItems {
          __typename
          ... on AgendaItem {
            displayText
            presenter
            startTime
            endTime
          }
        }
      }
      localization {
        localizationSet
      }
    }
  }
`